import { Users, LineChart, MessageSquareQuote } from 'lucide-react';

const InterviewPrepIcon = ({ className }) => (
  <svg
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.33333 2.66667C4.33333 3.40305 3.73638 4 3 4C2.26362 4 1.66667 3.40305 1.66667 2.66667C1.66667 1.93029 2.26362 1.33333 3 1.33333C3.73638 1.33333 4.33333 1.93029 4.33333 2.66667ZM0.333333 2.66667C0.333333 4.13943 1.52724 5.33333 3 5.33333C4.47276 5.33333 5.66667 4.13943 5.66667 2.66667C5.66667 1.19391 4.47276 0 3 0C1.52724 0 0.333333 1.19391 0.333333 2.66667ZM4.66667 9C4.66667 8.07953 3.92047 7.33333 3 7.33333C2.07953 7.33333 1.33333 8.07953 1.33333 9V10.6667H4.66667V9ZM6 12H0V9C0 7.34313 1.34315 6 3 6C4.65685 6 6 7.34313 6 9V12ZM11.6667 2.66667C11.6667 3.40305 11.0697 4 10.3333 4C9.59693 4 9 3.40305 9 2.66667C9 1.93029 9.59693 1.33333 10.3333 1.33333C11.0697 1.33333 11.6667 1.93029 11.6667 2.66667ZM7.66667 2.66667C7.66667 4.13943 8.8606 5.33333 10.3333 5.33333C11.8061 5.33333 13 4.13943 13 2.66667C13 1.19391 11.8061 0 10.3333 0C8.8606 0 7.66667 1.19391 7.66667 2.66667ZM12 9C12 8.07953 11.2538 7.33333 10.3333 7.33333C9.41287 7.33333 8.66667 8.07953 8.66667 9V10.6667H12V9ZM7.33333 10.6667V9C7.33333 7.34313 8.67647 6 10.3333 6C11.9902 6 13.3333 7.34313 13.3333 9V12H7.33333V10.6667Z"
      fill="currentColor"
    />
  </svg>
);

const FEATURES = [
  { icon: Users, label: '1:1 Mentorship' },
  { icon: LineChart, label: 'Industry level projects' },
  { icon: InterviewPrepIcon, label: 'Interview Prep' },
  { icon: MessageSquareQuote, label: 'AI Focused Curriculum' },
];

const MOBILE_ROWS = [
  [FEATURES[0], FEATURES[1]],
  [FEATURES[2], FEATURES[3]],
];

const ContentTags = () => {
  return (
    <>
      {/* Mobile: two rows of two features, per Figma mobile spec */}
      <div className="flex sm:hidden flex-col items-center justify-center gap-2 bg-[#FFFFFF33] rounded-xl py-2 px-3 w-[302px] h-14">
        {MOBILE_ROWS.map((row, rowIndex) => (
          <div key={rowIndex} className="flex items-center justify-center gap-3 w-full">
            {row.map(({ icon: Icon, label }, index) => (
              <div key={label} className="flex items-center gap-3">
                <div className="flex items-center gap-2 text-[#F8FAFC] font-[Gilroy-Regular] text-[12px] leading-4 tracking-[0.01em] whitespace-nowrap">
                  <Icon className="w-4 h-4" />
                  {label}
                </div>
                {index !== row.length - 1 && <div className="w-px h-3 bg-[#E2E8F0]" />}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Desktop: single row, wraps on narrower desktop widths instead of overflowing */}
      <div className="hidden sm:flex flex-wrap items-center justify-center gap-x-6 gap-y-3 bg-[#FFFFFF33] rounded-xl py-3 px-8 w-fit max-w-full">
        {FEATURES.map(({ icon: Icon, label }, index) => (
          <div key={label} className="flex items-center gap-6">
            <div className="flex items-center gap-3 text-[#F8FAFC] font-[Gilroy-Regular] text-[18px] leading-6 tracking-[0.02em] whitespace-nowrap">
              <Icon className="w-5 h-5" />
              {label}
            </div>
            {index !== FEATURES.length - 1 && <div className="h-6 w-px bg-[#E2E8F0]" />}
          </div>
        ))}
      </div>
    </>
  );
};

export default ContentTags;
